
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  wasSuccessfull: false,
};

const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    setWasSuccessfull: (state, action) => {
      state.wasSuccessfull = action.payload;
    },
  },
});

export const { setWasSuccessfull } = paymentSlice.actions;
export default paymentSlice.reducer;
